var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"INFO"},[_c('vk-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
          content:_vm.infoContent,
        }),expression:"{\n          content:infoContent,\n        }"}],attrs:{"name":"exclamation-circle-outlined","size":"22"}})],1),_c('div',{staticClass:"UNDERLINE"},[_vm._v("How to add multiple photos")])])
}
var staticRenderFns = []

export { render, staticRenderFns }